import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {createNotification} from "app/actions/notifications";
import {create as createRecord} from "app/requests/case-submissions";
import {ActionText} from "components/helpers";
import {valueFrom, valueFromTarget} from "lib/form";
import useAppContext from "lib/hooks/use-app-context";
import useContent from "lib/hooks/use-content";
import {withoutBlankValues} from "lib/object";
import Form from "./form";

const defaultRecord = ({user}) => {
  const fields = user ? {
    email: user.email,
    first_name: user.first_name,
    last_name: user.last_name
  } : {};

  return {
    categories: [],
    email: "",
    first_name: "",
    keywords: "",
    last_name: "",
    title: "",
    ...fields
  };
};

export default function CaseSubmissions() {
  const {dispatch, user} = useAppContext();
  const enabled = useContent("Cases", "Enable Submissions");
  const guidelines = useContent("Cases", "Guidelines");
  const navigate = useNavigate();
  const [record, setRecord] = useState(defaultRecord({user}));
  const onChange = ({target}) => (
    setRecord({...record, [target.name]: valueFromTarget(target)})
  );
  const onSubmit = (e) => {
    e.preventDefault();

    const updates = {...withoutBlankValues(record)};
    if(updates.keywords) {
      updates.keywords = updates.keywords.split(",").map((k) => k.trim());
    }

    if(Object.keys(updates).length === 0) {
      return dispatch(createNotification({
        content: "Please fill out the form before submitting",
        type: "danger"
      }));
    }

    createRecord({record: updates}).then(({message, success}) => {
      if(success) {
        navigate("/", {state: {message, type: "success"}});
      } else {
        dispatch(createNotification({content: message, type: "danger"}));
      }
    });
  };
  const value = (name, defaultValue) => valueFrom({defaultValue, name, objects: [record]});

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-8 offset-md-2 text-center">
          <div className="custom-html mb-3">
            <h2>Case Submission</h2>
            {!enabled && (
              <div className="text-center my-4">Submissions are currently closed{user?.admin && " but since you're an admin, we'll allow it"}</div>
            )}
            <ActionText.Content html={guidelines} />
          </div>
        </div>
      </div>
      {(enabled || user?.admin) && (
        <div className="row">
          <div className="col-md-8 offset-md-2">
            <Form onChange={onChange} onSubmit={onSubmit} value={value} />
          </div>
        </div>
      )}
    </div>
  );
}
